
import XLSX from 'xlsx'
import FileSaver from 'file-saver'

import { getDevDevList, getInsertDev, getUpdateDev, getDevTypeList, getDevByDevId, getCommDel, getDeviceState, getDevExport } from "@/api/device";
import { getProNameList, exportExl } from "@/api/project";
import { getDict } from '@/api/dict'
import moment from 'moment';

const token = sessionStorage.getItem('token')
export default {
    name: "deviceList",
    data() {

        return {
            selectVal: {//el-select的val
                allProject: '',
                deviceStatus: '',
                deviceType: '',
                deviceName: '',
            },

            tableData: [],
            tableColumn: [
                {
                    id: '0',
                    prop: 'device_id',
                    label: '设备编号',
                    sortable: "custom"
                }, {
                    id: '1',
                    prop: 'device_name',
                    label: '设备名称',
                    sortable: "custom"
                }, {
                    id: '2',
                    prop: 'sn',
                    label: 'SN序列号',
                    sortable: "custom"
                }, {
                    id: '3',
                    prop: 'device_type_name',
                    label: '设备类型',
                    sortable: "custom"
                }, {
                    id: '4',
                    prop: 'deviceBrandName',
                    label: '设备品牌',
                    // sortable: "custom"
                }, {
                    id: '5',
                    prop: 'deviceStatus',
                    label: '设备状态',
                    xqliType: true,
                    // sortable: "custom"
                }, {
                    id: '6',
                    prop: 'onlineTime',
                    label: '最近同步时间',
                    // sortable: "custom"
                }, {
                    id: '7',
                    prop: 'project_name',
                    label: '所属项目',
                    sortable: "custom"
                }, {
                    id: '9',
                    prop: 'handle',
                    label: '操作',
                    xqliHandle: true
                },
            ],
            total: 0,
            pageSize: 20,
            page: 1,

            multipleSelection: [],
            proIds: [],
            headTitle: '新建设备',
            pupUp: false,
            ruleForm: {
                id: '',
                sn: '',
                deviceName: '',
                deviceTypeId: '',
                deviceTypeName: '',
                customerId: '',
                customerName: '',
                projectId: '',
                projectName: '',
                deviceBrand: '',
                deviceSpec: '',
            },
            rules: {
                // sn: [{ required: true, message: '请输入SN序列号', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
                // deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
                // deviceTypeId: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
                // customerId: [{ required: true, message: '请选择所属客户', trigger: 'change' }],
                // projectId: [{ required: true, message: '请选择所属项目', trigger: 'change' }],
            },

            headers: {
                Authorization: token ? "Bearer " + token : ''
            },
            // action: '/heating/api/dev/uploadFile',
            action: '/manager/api/comm/uploadFile',
            fileList: [],//完成工单 图片list
            attachments: [],//完成工单 上传图片
            dialogVisible: false,
            dialogImageUrl: '',

            proNameList: [],
            devTypeList: [],
            attachmentIdList: [],
            order: "",
            sortBy: '',
            timer: null,
            deviceBrandList:[],
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.init()
    },
    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.timer)
    },

    methods: {

        init() {
            this.getDevDevList()//list
            this.getProNameList()//项目
            this.getDevTypeList()//设备类型名称list
            this.timer = setInterval(() => {
                this.getDevDevList()
            }, 30000)
        },

        async getDevDevList() {  //设备list
            let params = {
                page: this.page || 1,
                offset: this.pageSize || 20,
                sortBy: this.sortBy,
                order: this.order,
                deviceName: this.selectVal.deviceName,
                devTypeId: this.selectVal.deviceType,
                projectId: this.selectVal.allProject,
                deviceStatus: this.selectVal.deviceStatus,
            }
            const arr = []
            let data = []
            const res = await getDevDevList(params)
            if (res.code === 200) {
                data = res.data.rows
                this.total = res.data.total
                data.map(item => {
                    arr.push(item.device_id)
                })
            }
            const res1 = await getDict(1)//设备铭牌
            if(res1.code==200){
                this.deviceBrandList = res1.data
                res1.data.map(item => {
                    data.map(el => {
                        if (item.detail_ident == el.device_brand) {
                            el.deviceBrandName = item.detail_name
                        }
                    })
                })
            }
            const res2 = await getDeviceState(arr)//设备状态和在线时间
            if(res2.code==200){
                for (const resKey in res2.data) {
                    data.map(item => {
                        if (item.device_id === resKey) {
                            item.activateTime = res2.data[resKey].activateTime ? moment(res2.data[resKey].activateTime,'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : null
                            item.onlineTime = res2.data[resKey].onlineTime ? moment(res2.data[resKey].onlineTime,'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : null
                            // item.onlineTime = res2.data[resKey].onlineTime
                            item.deviceStatus = res2.data[resKey].deviceStatus
                        }
                    })
                }
            }
            this.tableData = data
        },

        async getProNameList() {
            const res = await getProNameList()
            if (res.code == 200) {
                this.proNameList = res.data
            }
        },

        async getDevTypeList() {
            const res = await getDevTypeList()
            if (res.code === 200) {
                this.devTypeList = res.data
            }
        },

        handleDetails(row) {
            this.$router.push({ name: 'deviceDetails', query: row })
        },
        handleAdd() {
            this.headTitle = '新建设备'
            this.pupUp = true
        },
        handleEdit(row) {
            this.headTitle = '编辑设备'
            this.pupUp = true
            this.ruleForm.id = row.id
            this.ruleForm.sn = row.sn
            this.ruleForm.deviceName = row.device_name
            this.ruleForm.deviceTypeId = row.device_type_id
            this.ruleForm.deviceTypeName = row.device_type_name

            this.ruleForm.customerId = row.customer_id
            this.ruleForm.customerName = row.customer_name
            this.ruleForm.projectId = row.project_id
            this.ruleForm.projectName = row.project_name
            this.ruleForm.deviceBrand = row.device_brand ? row.device_brand * 1 : ''
            this.ruleForm.deviceSpec = row.device_spec

            this.getDevByDevId()
        },



        handleDelete(row) {
            console.log(row)
        },

        changeCurrentPage(val) {
            this.page = val
            this.getDevDevList()
        },

        changeSize(val) {
            this.pageSize = val
            this.getDevDevList()
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.proIds = []
            val.map(el => {
                this.proIds.push(el.device_id)
            })
        },

        handleConfirm() {
            this.$refs.upload.uploadFiles
            this.attachmentIdList = []
            let params = {
                id: '', //设备id
                sn: this.ruleForm.sn, //SN序列号
                deviceName: this.ruleForm.deviceName, //设备名称
                deviceTypeId: this.ruleForm.deviceTypeId, //设备类型
                customerId: this.ruleForm.customerId, //所属客户
                customerName: this.ruleForm.customerName, //所属客户
                projectId: this.ruleForm.projectId, //所属项目
                projectName: this.ruleForm.projectName, //所属项目
                deviceBrand: this.ruleForm.deviceBrand, //品牌
                deviceSpec: this.ruleForm.deviceSpec, //规格型号
                attachments: this.attachments
            }
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.headTitle === '新建设备') {
                        getInsertDev(params).then(res => {
                            if (res.code == 200) {
                                this.pupUp = false
                                this.$refs['ruleForm'].resetFields();
                                this.getDevDevList()
                                this.$message({
                                    message: '新建成功',
                                    type: 'success'
                                });
                            }
                        })
                    } else if (this.headTitle === '编辑设备') {
                        params.id = this.ruleForm.id
                        getUpdateDev(params).then(res => {
                            if (res.code == 200) {
                                this.pupUp = false
                                this.$refs['ruleForm'].resetFields();
                                this.getDevDevList()
                                this.fileList = []
                                this.$message({
                                    message: '编辑成功',
                                    type: 'success'
                                });
                            }
                        })
                        // console.log(this.attachmentIdList,55555)
                        // if (this.attachmentIdList.length) {
                        //     getCommDel(this.attachmentIdList)
                        // }
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleCancel() {
            this.$refs['ruleForm'].resetFields();
        },


        handleOnSuccessAccomplish(res, file, fileList) {
            this.fileList = fileList
            if (res.code === 200) {
                this.attachments.push(res.data[0])
            }
        },


        handleChangeDevType(val) {
            this.selectVal.deviceType = val == 0 ? '' : val
            this.page = 1
            this.getDevDevList()
        },

        handleChangeDeviceStatus(val) {
            this.selectVal.deviceStatus = val == 0 ? '' : val
            this.page = 1
            this.getDevDevList()
        },

        handleChangeProjectId(val) {
            this.selectVal.allProject = val == 0 ? '' : val
            this.page = 1
            this.getDevDevList()
        },

        handleChangeDeviceName(val) {
            this.selectVal.deviceName = val == 0 ? '' : val
            this.page = 1
            this.getDevDevList()
        },

        handleReset() {//重置按钮
            this.page = 1
            for (let k in this.selectVal) {
                this.selectVal[k] = ''
            }
            this.getDevDevList()
        },
        // handleSearch() {
        //     this.getDevDevList()
        // },


        handleSort(prop, order) {//排序
            this.sortBy = prop
            if (order === 'ascending') {//升序
                this.order = "asc"
            } else if (order === 'descending') {//降序
                this.order = 'desc'
            } else {
                this.order = ""
                this.sortBy = ''
            }
            this.getDevDevList()//发送请求
        },

        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        async handleRemove(file) {
            this.fileList.map((item, index) => {
                if (file.uid == item.uid) {
                    this.fileList.splice(index, 1)
                    if (file.attachmentId) {
                        //如果删除的图片是已经绑定的图片将图片id存到attachmentIdList
                        this.attachmentIdList.push(file.attachmentId)
                    }
                }
            })

            const res = await getCommDel(file.attachmentId?file.attachmentId:file.response.data[0].id)
            if (res.code == 200) {
                this.$message({ message: '删除成功', type: 'success' });
            }
        },

        async getDevByDevId() {
            const res = await getDevByDevId(this.ruleForm.id)
            if (res.code == 200) {
                this.fileList = res.data[0].attachmentId ? res.data : []
            }
        },




        handleExportData() {//导出数据
            let tablelist = []
            if (this.multipleSelection.length === 0) {
                tablelist = this.tableData
            } else {
                tablelist = this.multipleSelection
            }
            this.processExportedTableData(this.tableColumn, tablelist, '设备信息' + moment().format('_YYYYMMDDHHmmss'))
            return;
            /* generate workbook object from table */
            // let wb = XLSX.utils.table_to_book(document.querySelector('#el-table'))
            // /* get binary string as output */
            // console.log(wb)
            // let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
            // console.log(wbout)

            // try {
            //     FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '导出设备.xlsx')
            // } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
            // return wbout
        },


        processExportedTableData(headerlist, tablelist, text) {
            let data = []
            let theade = []
            headerlist.forEach(item => {
                if (item.prop === 'handle') return;
                theade.push(item.label)
            })

            data.push(theade)
            tablelist.forEach(item => {
                let tbody = []
                headerlist.forEach(el => {
                    if (el.prop === 'handle') return;
                    if (el.prop === 'deviceStatus') {
                        let text = ''
                        switch (item[el.prop]) {
                            case -1:
                                text = '未激活'
                                break;
                            case 1:
                                text = '在线'
                                break;
                            case 2:
                                text = '离线'
                                break;
                            case 3:
                                text = '报警'
                                break;
                        }
                        tbody.push(text)
                        return;
                    }
                    tbody.push(item[el.prop])
                })
                data.push(tbody)
            })
            // return
            /* generate worksheet */
            const ws = XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
            /* generate workbook and add the worksheet */
            const wb = XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            /* save to file */
            XLSX.writeFile(wb, text + '.xlsx');

            // return {data,fileName}
        },

        closePop() {
            this.$refs.upload.clearFiles()
            this.fileList = []
            this.pupUp = false
        },
        // exportThing() {
        //     var exportDataIds;
        //     if (this.ids.length < 1) {
        //         exportDataIds = "";
        //     } else {
        //         exportDataIds = this.ids;
        //     }
        //     exportTemporaryAssetsDetail({ prodAccountIdArray: exportDataIds, importBatchNo: this.batchNo }).then(res => {

        //         if (res.status === 200) {
        //             let excel = 'data:application/vnd.ms-excel;base64,' + res.data;
        //             let blob = getBlob(excel);
        //             var date = new Date();
        //             var lastMonth = date.getMonth() + parseInt(1);
        //             var end = date.getFullYear() + '-' + lastMonth + '-' + date.getDate();
        //             let name = end + "-" + this.exportCustomerName + "-" + this.exportProdCatalogName + ".xls";
        //             fileDownload(blob, name);
        //         }
        //     })
        // },

        //导出
        async exportExl() {
            let params = {
                fileName: "设备数据",
                deviceIdents: this.proIds,
                devTitles: this.tableColumn
            }
            const res = await getDevExport(params)
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            const fileName = '设备数据'
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
        },


        //导出
        exportExl_1111() {
            let a = document.createElement('a')
            let tableColumn = encodeURIComponent(JSON.stringify(this.tableColumn))
            let proIds = encodeURIComponent(JSON.stringify(this.proIds))
            // console.log('/heating/api/pro/proExport?proTitles='+tableColumn+'&proIds='+proIds)
            // window.open('/heating/api/pro/proExport?proTitles='+tableColumn+'&proIds='+proIds)
            // a.href = '/heating/api/pro/proExport?proTitles='+tableColumn+'&proIds='+proIds
            // a.click();
            exportExl({ proTitles: this.tableColumn, proIds: this.proIds, fileName: '设备列表' }).then(res => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                const fileName = ''
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
            })
        },

    },
}
